import _ from 'lodash';
import {
  toTitleCase,
  getCategoryComponents,
  getDimensionIdForTalent,

  //Bechtel export
  // getBechtelCategoryComponents,
  // getBechtelDimensionIdForTalent,
  // getBechtelBenchmarkForTalent,

  //westinghouse export
  getWestinghouseCategoryComponents,
  getWestinghouseDimensionIdForTalent,
  getWestinghouseBenchmarkForTalent,

  //new stuff for new assessment
  getCategoryFromDimensionId,
  getDimensionsForCategory,
} from './index';

import { talentProfiles } from '../data/talentProfiles';
import { sevenImperatives, imperativesStages } from '../data/imperatives';
export function getTalentProfiles(){
  return talentProfiles;
}

export function getCoreProfileIdForTalentProfile(talentProfileId){
  const allTalentProfiles = getTalentProfiles();

  console.log('core profile ID for talent profile: ', talentProfileId, allTalentProfiles[talentProfileId].coreProfileId);

  return allTalentProfiles[talentProfileId].coreProfileId;
}

//const ROLE_PROP_NAME = 'Job Role';
const ROLE_PROP_NAME = 'FiveRoles';

const TALENT_CATEGORIES = ['motivation', 'interaction', 'cognition', 'execution'];

export const DIMENSION_CATEGORY_IDS = ['1','2','3','4'];

export function getLanguageOptions(){
  return [
    {
      value: 'en',
      label: 'English'
    },{
      value: 'fr',
      label: 'French'
      //label: 'Français'
    },{
      value: 'de',
      label: 'German'
      //label: 'Deutsch',
    },{
      value: 'es',
      label: 'Spanish'
      //label: 'Español'
    },{
      value: 'pt',
      label: 'Portuguese'
      //label: 'Português'
    },{
      value: 'zh',
      label: 'Chinese'
      //label: '中文'
    },{
      value: 'sv',
      label: 'Swedish'
      //label: 'Svenska',
    },{
      value: 'cs',
      label: 'Czech'
      //label: 'Čeština'
    },{
      value: 'hu',
      label: 'Hungarian'
      //label: 'Magyar'
    },{
      value: 'pl',
      label: 'Polish'
      //label: 'Polskie'
    },{
      value: 'ro',
      label: 'Romanian'
      //label: 'Română'
    },{
      value: 'nl',
      label: 'Dutch'
      //label: 'Nederlands'
    },{
      value: 'tr',
      label: 'Turkish',
      //label: 'Türkçe'
    },

    {
      value: 'it',
      label: 'Italian',
      //label: 'Italiano'
    },{
      value: 'ja',
      label: 'Japanese',
      //label: '日本語 (にほんご)'
    },{
      value: 'ru',
      label: 'Russian',
      //label: '	русский'
    },{
      value: 'sr',
      label: 'Serbian',
      //label: 'српски језик'
    },{
      value: 'th',
      label: 'Thai',
      //label: 'ไทย'
    },{
      value: 'uk',
      label: 'Ukrainian',
      //label: 'Українська'
    }

  ];
}

export function getLanguageNativeOptions(){
  return [
    {
      value: 'en',
      label: 'English'
    },{
      value: 'fr',
      //label: 'French'
      label: 'Français'
    },{
      value: 'de',
      //label: 'German'
      label: 'Deutsch',
    },{
      value: 'es',
      //label: 'Spanish'
      label: 'Español'
    },{
      value: 'pt',
      //label: 'Portuguese'
      label: 'Português'
    },{
      value: 'zh',
      //label: 'Chinese'
      label: '中文'
    },{
      value: 'sv',
      //label: 'Swedish'
      label: 'Svenska',
    },{
      value: 'cs',
      //label: 'Czech'
      label: 'Čeština'
    },{
      value: 'hu',
      //label: 'Hungarian'
      label: 'Magyar'
    },{
      value: 'pl',
      //label: 'Polish'
      label: 'Polskie'
    },{
      value: 'ro',
      //label: 'Romanian'
      label: 'Română'
    },{
      value: 'nl',
      //label: 'Dutch'
      label: 'Nederlands'
    },{
      value: 'tr',
      //label: 'Turkish',
      label: 'Türkçe'
    },

    {
      value: 'it',
      // label: 'Italian',
      label: 'Italiano'
    },{
      value: 'ja',
      // label: 'Japanese',
      label: '日本語 (にほんご)'
    },{
      value: 'ru',
      // label: 'Russian',
      label: '	русский'
    },{
      value: 'sr',
      // label: 'Serbian',
      label: 'српски језик'
    },{
      value: 'th',
      // label: 'Thai',
      label: 'ไทย'
    },{
      value: 'uk',
      // label: 'Ukrainian',
      label: 'Українська'
    }
  ];
}

export function getLanguageKeys(){
  return [
    'en',
    'fr',
    'de',
    'es',
    'pt',
    'zh',
    'sv',
    'cs',
    'hu',
    'pl',
    'ro',
    'nl',
    'tr',
    'it',
    'ja',
    'ru',
    'sr',
    'th',
    'uk'
  ];
}

export function getLangaugeLabel(languageKey){
  return _.find(getLanguageOptions(), { value: languageKey }).label;
}

export function getLangaugeNativeLabel(languageKey){
  return _.find(getLanguageNativeOptions(), { value: languageKey }).label;
}

export function getAllImperativeTasks(){
  let imperativeTasks = [];

  _.each(getSevenImperatives(), imperative => {
    imperativeTasks = _.union(imperativeTasks, imperative.tasks)
  });

  return imperativeTasks;
}

export function getSevenImperative(id){
  return _.find(getSevenImperatives(), {id});
}

export function getSevenImperatives(){
  return sevenImperatives;
}

export function getImperativesStages(){
  return imperativesStages;
}

// export function getDefaultOrganizationGoals(){
//   return {
//     behavior: [{
//       name: 'Problem Solver',
//       description: 'Problem Solver - You explore a range of options to find the best solution',
//       definition: '',
//       category: 'behavior',
//       goalType: 'do',
//       id: '100001'
//     },{
//       name: 'Collaborator',
//       description: 'Collaborator - You seek input to create a positive, open working enviornment',
//       definition: '',
//       category: 'behavior',
//       goalType: 'do',
//       id: '100002'
//     }],
//     skill: [{
//       name: 'Targeting',
//       description: 'Targeting',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200001'
//     },{
//       name: 'Opportunities',
//       description: 'Developing Opportunities',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200002'
//     },{
//       name: 'Planning',
//       description: 'Planning & Preparation',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200003'
//     },{
//       name: 'Conversations',
//       description: 'Productive Conversations',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200004'
//     },{
//       name: 'Executing',
//       description: 'Executing Sales Strategies',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200005'
//     },{
//       name: 'Relationships',
//       description: 'Developing Relationships',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200006'
//     },{
//       name: 'Closing',
//       description: 'Closing',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200007'
//     },{
//       name: 'Negotiating',
//       description: 'Negotiating',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200008'
//     },{
//       name: 'Account Management',
//       description: 'Account Management',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200009'
//     },{
//       name: 'Overcoming Objections',
//       description: 'Mastering Top 20 Objections',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200010'
//     },{
//       name: 'Demoing',
//       description: 'Running Effective Demos',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200011'
//     },{
//       name: 'PoV Presentation',
//       description: 'Presenting Company Point of View',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200012'
//     },{
//       name: 'ROI',
//       description: 'Developing ROI',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200013'
//     },{
//       name: 'Presenting Business Case',
//       description: 'Presenting Business Case',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200014'
//     },{
//       name: 'Imperatives',
//       description: 'Navigating 7 Imperatives',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200015'
//     }],
//     activity: [{
//       name: 'Calls',
//       description: 'Cold Calls (conversations)',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300001'
//     },{
//       name: 'Demos',
//       description: 'Client Demos',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300002'
//     },{
//       name: 'RFPs',
//       description: 'RFPs',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300003'
//     },{
//       name: 'Meetings',
//       description: 'In Person Meetings',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300004'
//     },{
//       name: 'Proposals',
//       description: 'Proposals',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300005'
//     }],
//     outcome: [{
//       name: 'Quota',
//       description: 'Quarterly Sales Quota',
//       definition: '',
//       category: 'outcome',
//       goalType: 'forecast',
//       id: '400001'
//     }],
//   };
// }

//FOR GP STRATEGIES
export function getDefaultOrganizationGoals(){
  return {
    behavior: [{
      name: 'Ambition',
      description: 'Leads with consistency and objectivity through defined, measurable performance criteria.',
      definition: 'Leads with consistency and objectivity through defined, measurable performance criteria.',
      category: 'behavior',
      goalType: 'do',
      id: '100001',
    },{
      name: 'Confidence',
      description: 'Sets high standards and applies rigorous talent and coaching practices to maximize growth through people.',
      definition: 'Sets high standards and applies rigorous talent and coaching practices to maximize growth through people.',
      category: 'behavior',
      goalType: 'do',
      id: '100002',
    },{
      name: 'Competition',
      description: 'Driven to be better than others.  Inspires team desire to compete through consistent focus on how we will win.',
      definition: 'Driven to be better than others.  Inspires team desire to compete through consistent focus on how we will win.',
      category: 'behavior',
      goalType: 'do',
      id: '100003',
    },{
      name: 'Persistence',
      description: 'Applies Increased effort & tenacity in the face of resistance to reach a goal.',
      definition: 'Applies Increased effort & tenacity in the face of resistance to reach a goal.',
      category: 'behavior',
      goalType: 'do',
      id: '100004',
    },{
      name: 'Networker',
      description: 'Initiates relationships & qualifies prospects through engaging in conversation, then establishing rapport.',
      definition: 'Initiates relationships & qualifies prospects through engaging in conversation, then establishing rapport.',
      category: 'behavior',
      goalType: 'do',
      id: '100005',
    },{
      name: 'Relator',
      description: 'Builds authentic friendships by demonstrating care & concern for associate & customer needs.',
      definition: 'Builds authentic friendships by demonstrating care & concern for associate & customer needs.',
      category: 'behavior',
      goalType: 'do',
      id: '100006',
    },{
      name: 'Advisor',
      description: 'Derives significant satisfaction from contributing to the growth and success of customers. ',
      definition: 'Derives significant satisfaction from contributing to the growth and success of customers. ',
      category: 'behavior',
      goalType: 'do',
      id: '100007',
    },{
      name: 'Collaborator',
      description: 'Aligns efforts through complementary work streams and collaboration in reaching a common goal.',
      definition: 'Aligns efforts through complementary work streams and collaboration in reaching a common goal.',
      category: 'behavior',
      goalType: 'do',
      id: '100008',
    },{
      name: 'Individualizer',
      description: 'Listens and understands buyer’s needs, emotions, and desires to deliver a value through offering.',
      definition: 'Listens and understands buyer’s needs, emotions, and desires to deliver a value through offering.',
      category: 'behavior',
      goalType: 'do',
      id: '100009',
    },{
      name: 'Analytical',
      description: 'Reviews patterns in data and commercials to evaluate opportunities, illuminate compelling differences from competitors, anticipate future needs, and improve win plans.',
      definition: 'Reviews patterns in data and commercials to evaluate opportunities, illuminate compelling differences from competitors, anticipate future needs, and improve win plans.',
      category: 'behavior',
      goalType: 'do',
      id: '100010',
    },{
      name: 'Adaptability',
      description: 'Modifies approach to position offering to serve unique requirements and constraints of buyer.',
      definition: 'Modifies approach to position offering to serve unique requirements and constraints of buyer.',
      category: 'behavior',
      goalType: 'do',
      id: '100011',
    },{
      name: 'Learning Agility',
      description: 'Routinely gathers information and knowledge from credible sources in order to build expertise and value to customer.',
      definition: 'Routinely gathers information and knowledge from credible sources in order to build expertise and value to customer.',
      category: 'behavior',
      goalType: 'do',
      id: '100012',
    },{
      name: 'Problem Solver',
      description: 'Uncovers root cause, explores alternatives, evaluates consequences, and applies creative resolutions.',
      definition: 'Uncovers root cause, explores alternatives, evaluates consequences, and applies creative resolutions.',
      category: 'behavior',
      goalType: 'do',
      id: '100013',
    },{
      name: 'Focus',
      description: 'Sets clear goals and maintains consistent direction for continual progress towards priority outcomes.',
      definition: 'Sets clear goals and maintains consistent direction for continual progress towards priority outcomes.',
      category: 'behavior',
      goalType: 'do',
      id: '1000014',
    },{
      name: 'Accountability',
      description: 'Shows dedication, commitment and ownership when executing tasks.',
      definition: 'Shows dedication, commitment and ownership when executing tasks.',
      category: 'behavior',
      goalType: 'do',
      id: '100015',
    },{
      name: 'Persuasion',
      description: 'Naturally takes command, addresses conflict, and asserts perspective. Gains agreement from others via logic and alternatives.',
      definition: 'Naturally takes command, addresses conflict, and asserts perspective. Gains agreement from others via logic and alternatives.',
      category: 'behavior',
      goalType: 'do',
      id: '100016',
    },{
      name: 'Discipline',
      description: 'Highly structured and attentive to detail. Plans ahead and manages schedule to deliver on time.',
      definition: 'Highly structured and attentive to detail. Plans ahead and manages schedule to deliver on time.',
      category: 'behavior',
      goalType: 'do',
      id: '100017',
    }],
    /*
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100004',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100005',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100006',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100007',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100008',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100009',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100010',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100011',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100012',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100013',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '1000014',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100015',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100016',
  }],
  */

    skill: [
      /*
    {
      name: 'Operational Excellence',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Operational Excellence, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Operational Excellence, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      category: 'skill',
      goalType: 'do',
      id: '200001',
      ratings: []
    },{
      name: 'Asset Performance Management',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Asset Performance Management, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Asset Performance Management, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      category: 'skill',
      goalType: 'do',
      id: '200002'
    },{
      name: 'Learning & Development',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Technical and non-technical Learning & Development needs, as well as GP’s comprehensive product, services, e-Learning, instructor-led training, hands-on training, and virtual instructor-led training, offerings.  * Includes GP’s approach to custom learning & development programs, and GPiLEARN+ capabilities and content.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Technical and non-technical Learning & Development needs, as well as GP’s comprehensive product, services, e-Learning, instructor-led training, hands-on training, and virtual instructor-led training, offerings.  * Includes GP’s approach to custom learning & development programs, and GPiLEARN+ capabilities and content.',
      category: 'skill',
      goalType: 'do',
      id: '200003'
    },{
      name: 'EtaPRO Performance and Condition Monitoring',
      description: 'Demonstrates Basic Understanding of thermal performance monitoring and asset condition monitoring.  Understanding of customer needs and market drivers for monitoring and diagnostics at power plants, refineries, and in technical industries.  Understanding of EtaPRO and its suite of technologies (Virtual Plant, Advanced Pattern Recognition, Predictor, EPArchive).  Ability to develop customer specific business case for justification of investment into EtaPRO',
      definition: 'Demonstrates Basic Understanding of thermal performance monitoring and asset condition monitoring.  Understanding of customer needs and market drivers for monitoring and diagnostics at power plants, refineries, and in technical industries.  Understanding of EtaPRO and its suite of technologies (Virtual Plant, Advanced Pattern Recognition, Predictor, EPArchive).  Ability to develop customer specific business case for justification of investment into EtaPRO',
      category: 'skill',
      goalType: 'do',
      id: '200004'
    },{
      name: 'Leadership Development & Employee Engagement',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Leadership Development and employee engagement, as well as GP’s comprehensive service offerings via BlessingWhite.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Leadership Development and employee engagement, as well as GP’s comprehensive service offerings via BlessingWhite.',
      category: 'skill',
      goalType: 'do',
      id: '200005'
    },{
      name: 'Organizational Change Management',
      description: 'Demonstrates Expert Knowledge of customer needs regarding Organizational Change Management, and the business drivers around culture change, as well as GP’s OCM service offerings.',
      definition: 'Demonstrates Expert Knowledge of customer needs regarding Organizational Change Management, and the business drivers around culture change, as well as GP’s OCM service offerings.',
      category: 'skill',
      goalType: 'do',
      id: '200006'
    },{
      name: 'Platform Adoption',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for digital transformation and large technology and software deployment, as well as GP’s Platform Adoption services.  This includes our capabilities with SAP, SucceesFactors, Cornerstone, and other ERP and Learning & Development support services.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for digital transformation and large technology and software deployment, as well as GP’s Platform Adoption services.  This includes our capabilities with SAP, SucceesFactors, Cornerstone, and other ERP and Learning & Development support services.',
      category: 'skill',
      goalType: 'do',
      id: '200007'
    },{
      name: 'Competition',
      description: 'Demonstrates Expert Knowledge of GP Strategies competition for our varied product and service offerings.  Articulates the competitive value proposition, and how we position GP Strategies to win each competitive engagement.',
      definition: 'Demonstrates Expert Knowledge of GP Strategies competition for our varied product and service offerings.  Articulates the competitive value proposition, and how we position GP Strategies to win each competitive engagement.',
      category: 'skill',
      goalType: 'do',
      id: '200008'
    },{
      name: 'Industry Knowledge',
      description: 'Demonstrates Expert Knowledge of trends, regulations, emerging technologies, and other factors that affect the EOG markets and our customer’s strategic direction, tactics, funded projects, and overall ability to spend.',
      definition: 'Demonstrates Expert Knowledge of trends, regulations, emerging technologies, and other factors that affect the EOG markets and our customer’s strategic direction, tactics, funded projects, and overall ability to spend.',
      category: 'skill',
      goalType: 'do',
      id: '200009'
    },{
      name: 'Customer Knowledge',
      description: 'Demonstrates Expert Knowledge of varied business structures, organizational structures, and their place in the EOG industries.  Incorporates this knowledge to effectively review public information, and engage customer contact to learn about their strategic direction and business plans.  Ability to consume this data and determine winning strategies to grow key customers.',
      definition: 'Demonstrates Expert Knowledge of varied business structures, organizational structures, and their place in the EOG industries.  Incorporates this knowledge to effectively review public information, and engage customer contact to learn about their strategic direction and business plans.  Ability to consume this data and determine winning strategies to grow key customers.',
      category: 'skill',
      goalType: 'do',
      id: '200010'
    }*/
    {
      name: 'Negotiation Skills',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200001'
    },
    {
      name: 'Presentation & Meeting skills',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200002'
    },
    {
      name: 'Platform Adoption',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200003'
    },
    {
      name: 'Sales Process',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200004'
    },
    {
      name: 'Proposal Writing',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200005'
    },
  ],

    activity: [{
      name: 'Cold Calls',
      description: 'Cold Calls',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300001'
    },{
      name: 'Discovery Calls',
      description: 'Discovery Calls',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300002'
    },{
      name: 'Presentations',
      description: 'Presentations',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300003'
    },{
      name: 'Executive Meetings',
      description: 'Executive Meetings',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300004'
    },{
      name: 'Proposals',
      description: 'Proposals',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300005'
    },{
      name: 'Active Pipeline',
      description: 'Active Pipeline',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300006',
    }],

    outcome: [{
      name: 'Quota',
      description: 'Quarterly Sales Quota',
      definition: '',
      category: 'outcome',
      goalType: 'forecast',
      id: '400001'
    }],
  };
}

export function scoreCompetitiveAdvantagesForTalentProfile(talentProfile, scores){

  let dimensionsAboveBenchmark = [];

  //get benchmarks for custom talent profile (if is custom), if doesn't exist use core profile benchmarks
  let globalBenchmarks = talentProfiles[talentProfile].globalBenchmarks || talentProfiles[getCoreProfileIdForTalentProfile(talentProfile)].globalBenchmarks;

  _.each(scores, (score, dimensionId) => {
    const profileBenchmarkForScore = globalBenchmarks[dimensionId];

    if(score > profileBenchmarkForScore && profileBenchmarkForScore > 0){
      dimensionsAboveBenchmark.push({
        dimension: dimensionId,
        score: score,
        benchmark: profileBenchmarkForScore,
        percentAbove: Math.round(((score / profileBenchmarkForScore) - 1) * 100.)
      });
    }
  });

  return _.take(_.reverse(_.sortBy(dimensionsAboveBenchmark, 'percentAbove')), 6);
}

//deprecated
export function getUserCompetitiveAdvantages(userData){
  //getWestinghouseBenchmarkForTalent
  let talentsAboveBenchmark = [];

  // console.log('getUserCompetitiveAdvantages::userData: ', userData);

  _.each(TALENT_CATEGORIES, talentCategory => {

    const talentCategoryComponentsForUser = getWestinghouseCategoryComponents(talentCategory, userData[ROLE_PROP_NAME]);

    console.log('talentCategoryComponentsForUser: ', talentCategoryComponentsForUser);

    _.each(talentCategoryComponentsForUser, componentName => {

      const benchmark = getWestinghouseBenchmarkForTalent(componentName, userData[ROLE_PROP_NAME]);
      const scoreForComponent = userData[getWestinghouseDimensionIdForTalent(componentName)] || 0;

      // console.log(`benchmark for ${componentName} = ${benchmark}`);
      // console.log(`score for ${componentName} = ${scoreForComponent}`);

      if(scoreForComponent > benchmark){
        // console.log('ABOVE AVG!');
        talentsAboveBenchmark.push({
          id: componentName,
          score: scoreForComponent,
          benchmark,
          percentage: Math.round(((scoreForComponent / benchmark) - 1) * 100.)
        });
      }
    });
  });

  //limit to 8, sort by percentage above benchmark
  return _.take(_.reverse(_.sortBy(talentsAboveBenchmark, 'percentage')), 6);
}
//deprecated - used for calculating which users have competitive advantages via chrome console
//window.getUserCompetitiveAdvantages = getUserCompetitiveAdvantages;

//deprecated

export function getUserStrengthsFromAllScores(userData){

  // console.log('userData: %o', userData);

  if(!userData){
    return false;
  }

  let scoresForUser = {};
  let totalScoreForUser = 0;
  let adjustedTotalScoreForUser = 0;

  const SCORE_POWER_FOR_INTRODUCTING_ARTIFICIAL_VARIANCE = 3;

  _.each(TALENT_CATEGORIES, function(talentCategory){

    scoresForUser[talentCategory] = {};

    let talentCategoryTotal = 0;
    let adjustedTalentCategoryTotal = 0;

    const talentCategoryComponentsForUser = getWestinghouseCategoryComponents(talentCategory, userData[ROLE_PROP_NAME]);

    // console.log('talentCategoryComponentsForUser: ', talentCategoryComponentsForUser);

    //go through each component and add to talent category total + set "raw" score value
    _.each(talentCategoryComponentsForUser, function(componentName){

      //console.log('scoring user component: ', componentName);

      scoresForUser[talentCategory][componentName] = {};
      const scoreForComponent = userData[getWestinghouseDimensionIdForTalent(componentName)] || 0;

      // console.log('userData: %o', userData);
      // console.log('componentName: %o', getWestinghouseDimensionIdForTalent(componentName));
      // console.log('scoreForComponent: %o', scoreForComponent);

      const adjustedScoreForComponent = Math.pow(scoreForComponent, SCORE_POWER_FOR_INTRODUCTING_ARTIFICIAL_VARIANCE);

      talentCategoryTotal += adjustedScoreForComponent
      adjustedTalentCategoryTotal += adjustedScoreForComponent
      scoresForUser[talentCategory][componentName]['raw'] = scoreForComponent;
      scoresForUser[talentCategory][componentName]['adjusted'] = adjustedScoreForComponent;
    });

    //iterate through again now that we have total to compute percentages
    _.each(getWestinghouseCategoryComponents(talentCategory, userData[ROLE_PROP_NAME]), function(componentName){
      const scoreForComponent = userData[getWestinghouseDimensionIdForTalent(componentName)] || 0;

      const adjustedScoreForComponent = Math.pow(scoreForComponent, SCORE_POWER_FOR_INTRODUCTING_ARTIFICIAL_VARIANCE);

      scoresForUser[talentCategory][componentName]['percent'] = adjustedScoreForComponent * 100 / talentCategoryTotal;
    });

    //need to normalize this data as some talent categories will have 3, some 4, and some 5 talents.
    //OLD way...
    // scoresForUser[talentCategory]['raw'] = talentCategoryTotal;
    // totalScoreForUser += talentCategoryTotal;
    //NEW way...
    const talentCategoryAverage = talentCategoryTotal / talentCategoryComponentsForUser.length;
    const adjustedTalentCategoryAverage = adjustedTalentCategoryTotal / talentCategoryComponentsForUser.length;

    scoresForUser[talentCategory]['raw'] = talentCategoryAverage;
    scoresForUser[talentCategory]['adjusted'] = adjustedTalentCategoryAverage;

    totalScoreForUser += talentCategoryAverage;
    adjustedTotalScoreForUser += adjustedTalentCategoryAverage;
  });

  _.each(TALENT_CATEGORIES, function(talentCategory){
    //scoresForUser[talentCategory]['percent'] = scoresForUser[talentCategory].raw * 100 / totalScoreForUser;
    scoresForUser[talentCategory]['percent'] = scoresForUser[talentCategory].adjusted * 100 / adjustedTotalScoreForUser;
  });

  //console.log('scoresForUser: ', scoresForUser);

  //let allScoresTotal = _.reduce(userData, function())

  //console.log('scoresForUser: ', scoresForUser);
  return scoresForUser;
}

export function getDimensionScores(scores, scaleVarianceFactor){
  if(!scores){
    return false;
  }

  // console.log('getDimensionScores with scores:', scores);

  let dimensionScores = {};
  let totalScoreForUser = 0;
  let adjustedTotalScoreForUser = 0;

  const scoredDimensionIds = Object.keys(scores);

  _.each(DIMENSION_CATEGORY_IDS, function(dimensionCategoryId){

    dimensionScores[dimensionCategoryId] = {};
    dimensionScores[dimensionCategoryId]['dimensions'] = {};

    let dimensionCategoryTotal = 0;
    let adjustedDimensionCategoryTotal = 0;

    const dimensionCategoryScoredComponents = getDimensionsForCategory(scoredDimensionIds, dimensionCategoryId);

    // console.log('dimensionCategoryScoredComponents: ', dimensionCategoryScoredComponents);

    //go through each component and add to talent category total + set "raw" score value
    _.each(dimensionCategoryScoredComponents, function(dimensionId){

      // console.log('getting score for dimensionId: ', dimensionId);

      dimensionScores[dimensionCategoryId]['dimensions'][dimensionId] = {};
      //const scoreForDimension = (scores[dimensionId] || {})['avg'] || 0;
      const scoreForDimension = scores[dimensionId] || 0;

      // console.log('scoreForDimension: ', scoreForDimension);

      const adjustedScoreForDimension = Math.pow(scoreForDimension, scaleVarianceFactor);

      dimensionCategoryTotal += scoreForDimension;
      adjustedDimensionCategoryTotal += adjustedScoreForDimension;
      dimensionScores[dimensionCategoryId]['dimensions'][dimensionId]['avg'] = scoreForDimension;
      dimensionScores[dimensionCategoryId]['dimensions'][dimensionId]['adjusted'] = adjustedScoreForDimension;
    });

    //iterate through again now that we have total to compute percentages
    //also add dimension id
    _.each(dimensionCategoryScoredComponents, dimensionId => {
      dimensionScores[dimensionCategoryId]['dimensions'][dimensionId]['id'] = dimensionId;
      dimensionScores[dimensionCategoryId]['dimensions'][dimensionId]['percent'] = dimensionScores[dimensionCategoryId]['dimensions'][dimensionId]['adjusted'] * 100 / adjustedDimensionCategoryTotal;
    });

    const dimensionCategoryAverage = dimensionCategoryTotal / dimensionCategoryScoredComponents.length;
    const adjustedDimensionCategoryAverage = adjustedDimensionCategoryTotal / dimensionCategoryScoredComponents.length;

    dimensionScores[dimensionCategoryId]['raw'] = dimensionCategoryAverage;
    dimensionScores[dimensionCategoryId]['adjusted'] = adjustedDimensionCategoryAverage;

    totalScoreForUser += dimensionCategoryAverage;
    adjustedTotalScoreForUser += adjustedDimensionCategoryAverage;
  });

  _.each(DIMENSION_CATEGORY_IDS, function(dimensionCategoryId){
    dimensionScores[dimensionCategoryId]['id'] = dimensionCategoryId;
    dimensionScores[dimensionCategoryId]['percent_raw'] = dimensionScores[dimensionCategoryId]['raw'] * 100 / totalScoreForUser;
    dimensionScores[dimensionCategoryId]['percent'] = dimensionScores[dimensionCategoryId]['adjusted'] * 100 / adjustedTotalScoreForUser;
  });

  // console.log('dimensionScores: ', dimensionScores);
  return dimensionScores;
}

export function getOrderedDimensionScores(scores, scaleVarianceFactor = 2.5){
  const dimensionScores = getDimensionScores(scores, scaleVarianceFactor);

  if(!scores){
    return false;
  }

  let orderedDimensionScores = [];

  const orderedDimensionCategories = _.sortBy(dimensionScores, dimensionCategory => {
    return -1 * dimensionCategory.adjusted;
  });

  // console.log('orderedDimensionCategories: ', orderedDimensionCategories);

  _.each(orderedDimensionCategories, function(dimensionCategory){

    const orderedDimensionsForCategory = _.sortBy(dimensionCategory.dimensions, dimension => {
      return -1 * dimension.adjusted;
    });

    orderedDimensionScores.push({
      ...dimensionCategory,
      dimensions: orderedDimensionsForCategory
    });
  });

  // console.log('orderedDimensionScores: ', orderedDimensionScores);
  return orderedDimensionScores;
}

//deprecated
export function getOrderedUserStrengthsFromAllScores(userData){
  const userScoreData = getUserStrengthsFromAllScores(userData);

  if(!userScoreData){
    return false;
  }

  let talentCategoriesArray = [];

  _.each(TALENT_CATEGORIES, function(categoryId){

    talentCategoriesArray.push({
      id: categoryId,
      name: toTitleCase(categoryId),
      raw: userScoreData[categoryId].raw,
      adjusted: userScoreData[categoryId].adjusted,
      percent: userScoreData[categoryId].percent,
    });
  });

  const sortedTalentCategoriesArray = _.sortBy(talentCategoriesArray, function(talentCategory){
    return -1 * talentCategory.percent;
  });

  _.each(sortedTalentCategoriesArray, function(talentCategory){

    const talentCategoryComponentsForUser = getWestinghouseCategoryComponents(talentCategory.id, userData[ROLE_PROP_NAME]);

    // console.log('talentCategoryComponentsForUser: ', talentCategoryComponentsForUser);

    let talentCategoryTalents = [];

    _.each(talentCategoryComponentsForUser, function(componentName){

      talentCategoryTalents.push({
        id: componentName,
        name: toTitleCase(componentName),
        ...userScoreData[talentCategory.id][componentName]
      });
    });

    const sortedTalentCategoryTalents = _.sortBy(talentCategoryTalents, function(talentScores){
      return -1 * talentScores.percent;
    });

    talentCategory.talents = sortedTalentCategoryTalents;
  });

  //console.log('sortedTalentCategoriesArray: ', sortedTalentCategoriesArray);
  return sortedTalentCategoriesArray;
}

//deprecated
export function getUserDataFromAllUsers(userId, allUserData){
  const userData = _.find(allUserData, person => {
    return parseInt(person.ProfileID) === parseInt(userId);
  });

  return userData;
}

//https://gist.github.com/keeguon/2310008
export function getCountryOptions(){
  return [
    {
      "label": "Afghanistan",
      "value": "af"
    },
    {
      "label": "Åland Islands",
      "value": "ax"
    },
    {
      "label": "Albania",
      "value": "al"
    },
    {
      "label": "Algeria",
      "value": "dz"
    },
    {
      "label": "American Samoa",
      "value": "as"
    },
    {
      "label": "AndorrA",
      "value": "ad"
    },
    {
      "label": "Angola",
      "value": "ao"
    },
    {
      "label": "Anguilla",
      "value": "ai"
    },
    {
      "label": "Antarctica",
      "value": "aq"
    },
    {
      "label": "Antigua and Barbuda",
      "value": "ag"
    },
    {
      "label": "Argentina",
      "value": "ar"
    },
    {
      "label": "Armenia",
      "value": "am"
    },
    {
      "label": "Aruba",
      "value": "aw"
    },
    {
      "label": "Australia",
      "value": "au"
    },
    {
      "label": "Austria",
      "value": "at"
    },
    {
      "label": "Azerbaijan",
      "value": "az"
    },
    {
      "label": "Bahamas",
      "value": "bs"
    },
    {
      "label": "Bahrain",
      "value": "bh"
    },
    {
      "label": "Bangladesh",
      "value": "bd"
    },
    {
      "label": "Barbados",
      "value": "bb"
    },
    {
      "label": "Belarus",
      "value": "by"
    },
    {
      "label": "Belgium",
      "value": "be"
    },
    {
      "label": "Belize",
      "value": "bz"
    },
    {
      "label": "Benin",
      "value": "bj"
    },
    {
      "label": "Bermuda",
      "value": "bm"
    },
    {
      "label": "Bhutan",
      "value": "bt"
    },
    {
      "label": "Bolivia",
      "value": "bo"
    },
    {
      "label": "Bosnia and Herzegovina",
      "value": "ba"
    },
    {
      "label": "Botswana",
      "value": "bw"
    },
    {
      "label": "Bouvet Island",
      "value": "bv"
    },
    {
      "label": "Brazil",
      "value": "br"
    },
    {
      "label": "British Indian Ocean Territory",
      "value": "io"
    },
    {
      "label": "Brunei Darussalam",
      "value": "bn"
    },
    {
      "label": "Bulgaria",
      "value": "bg"
    },
    {
      "label": "Burkina Faso",
      "value": "bf"
    },
    {
      "label": "Burundi",
      "value": "bi"
    },
    {
      "label": "Cambodia",
      "value": "kh"
    },
    {
      "label": "Cameroon",
      "value": "cm"
    },
    {
      "label": "Canada",
      "value": "ca"
    },
    {
      "label": "Cape Verde",
      "value": "cv"
    },
    {
      "label": "Cayman Islands",
      "value": "ky"
    },
    {
      "label": "Central African Republic",
      "value": "cf"
    },
    {
      "label": "Chad",
      "value": "td"
    },
    {
      "label": "Chile",
      "value": "cl"
    },
    {
      "label": "China",
      "value": "cn"
    },
    {
      "label": "Christmas Island",
      "value": "cx"
    },
    {
      "label": "Cocos (Keeling) Islands",
      "value": "cc"
    },
    {
      "label": "Colombia",
      "value": "co"
    },
    {
      "label": "Comoros",
      "value": "km"
    },
    {
      "label": "Congo",
      "value": "cg"
    },
    {
      "label": "Congo, The Democratic Republic of the",
      "value": "cd"
    },
    {
      "label": "Cook Islands",
      "value": "ck"
    },
    {
      "label": "Costa Rica",
      "value": "cr"
    },
    {
      "label": "Cote D'Ivoire",
      "value": "ci"
    },
    {
      "label": "Croatia",
      "value": "hr"
    },
    {
      "label": "Cuba",
      "value": "cu"
    },
    {
      "label": "Cyprus",
      "value": "cy"
    },
    {
      "label": "Czech Republic",
      "value": "cz"
    },
    {
      "label": "Denmark",
      "value": "dk"
    },
    {
      "label": "Djibouti",
      "value": "dj"
    },
    {
      "label": "Dominica",
      "value": "dm"
    },
    {
      "label": "Dominican Republic",
      "value": "do"
    },
    {
      "label": "Ecuador",
      "value": "ec"
    },
    {
      "label": "Egypt",
      "value": "eg"
    },
    {
      "label": "El Salvador",
      "value": "sv"
    },
    {
      "label": "Equatorial Guinea",
      "value": "gq"
    },
    {
      "label": "Eritrea",
      "value": "er"
    },
    {
      "label": "Estonia",
      "value": "ee"
    },
    {
      "label": "Ethiopia",
      "value": "et"
    },
    {
      "label": "Falkland Islands (Malvinas)",
      "value": "fk"
    },
    {
      "label": "Faroe Islands",
      "value": "fo"
    },
    {
      "label": "Fiji",
      "value": "fj"
    },
    {
      "label": "Finland",
      "value": "fi"
    },
    {
      "label": "France",
      "value": "fr"
    },
    {
      "label": "French Guiana",
      "value": "gf"
    },
    {
      "label": "French Polynesia",
      "value": "pf"
    },
    {
      "label": "French Southern Territories",
      "value": "tf"
    },
    {
      "label": "Gabon",
      "value": "ga"
    },
    {
      "label": "Gambia",
      "value": "gm"
    },
    {
      "label": "Georgia",
      "value": "ge"
    },
    {
      "label": "Germany",
      "value": "de"
    },
    {
      "label": "Ghana",
      "value": "gh"
    },
    {
      "label": "Gibraltar",
      "value": "gi"
    },
    {
      "label": "Greece",
      "value": "gr"
    },
    {
      "label": "Greenland",
      "value": "gl"
    },
    {
      "label": "Grenada",
      "value": "gd"
    },
    {
      "label": "Guadeloupe",
      "value": "gp"
    },
    {
      "label": "Guam",
      "value": "gu"
    },
    {
      "label": "Guatemala",
      "value": "gt"
    },
    {
      "label": "Guernsey",
      "value": "gg"
    },
    {
      "label": "Guinea",
      "value": "gn"
    },
    {
      "label": "Guinea-Bissau",
      "value": "gw"
    },
    {
      "label": "Guyana",
      "value": "gy"
    },
    {
      "label": "Haiti",
      "value": "ht"
    },
    {
      "label": "Heard Island and Mcdonald Islands",
      "value": "hm"
    },
    {
      "label": "Holy See (Vatican City State)",
      "value": "va"
    },
    {
      "label": "Honduras",
      "value": "hn"
    },
    {
      "label": "Hong Kong",
      "value": "hk"
    },
    {
      "label": "Hungary",
      "value": "hu"
    },
    {
      "label": "Iceland",
      "value": "is"
    },
    {
      "label": "India",
      "value": "in"
    },
    {
      "label": "Indonesia",
      "value": "id"
    },
    {
      "label": "Iran, Islamic Republic Of",
      "value": "ir"
    },
    {
      "label": "Iraq",
      "value": "iq"
    },
    {
      "label": "Ireland",
      "value": "ie"
    },
    {
      "label": "Isle of Man",
      "value": "im"
    },
    {
      "label": "Israel",
      "value": "il"
    },
    {
      "label": "Italy",
      "value": "it"
    },
    {
      "label": "Jamaica",
      "value": "jm"
    },
    {
      "label": "Japan",
      "value": "jp"
    },
    {
      "label": "Jersey",
      "value": "je"
    },
    {
      "label": "Jordan",
      "value": "jo"
    },
    {
      "label": "Kazakhstan",
      "value": "kz"
    },
    {
      "label": "Kenya",
      "value": "ke"
    },
    {
      "label": "Kiribati",
      "value": "ki"
    },
    {
      "label": "Korea, Democratic People'S Republic of",
      "value": "kp"
    },
    {
      "label": "Korea, Republic of",
      "value": "kr"
    },
    {
      "label": "Kuwait",
      "value": "kw"
    },
    {
      "label": "Kyrgyzstan",
      "value": "kg"
    },
    {
      "label": "Lao People'S Democratic Republic",
      "value": "la"
    },
    {
      "label": "Latvia",
      "value": "lv"
    },
    {
      "label": "Lebanon",
      "value": "lb"
    },
    {
      "label": "Lesotho",
      "value": "ls"
    },
    {
      "label": "Liberia",
      "value": "lr"
    },
    {
      "label": "Libyan Arab Jamahiriya",
      "value": "ly"
    },
    {
      "label": "Liechtenstein",
      "value": "li"
    },
    {
      "label": "Lithuania",
      "value": "lt"
    },
    {
      "label": "Luxembourg",
      "value": "lu"
    },
    {
      "label": "Macao",
      "value": "mo"
    },
    {
      "label": "Macedonia, The Former Yugoslav Republic of",
      "value": "mk"
    },
    {
      "label": "Madagascar",
      "value": "mg"
    },
    {
      "label": "Malawi",
      "value": "mw"
    },
    {
      "label": "Malaysia",
      "value": "my"
    },
    {
      "label": "Maldives",
      "value": "mv"
    },
    {
      "label": "Mali",
      "value": "ml"
    },
    {
      "label": "Malta",
      "value": "mt"
    },
    {
      "label": "Marshall Islands",
      "value": "mh"
    },
    {
      "label": "Martinique",
      "value": "mq"
    },
    {
      "label": "Mauritania",
      "value": "mr"
    },
    {
      "label": "Mauritius",
      "value": "mu"
    },
    {
      "label": "Mayotte",
      "value": "yt"
    },
    {
      "label": "Mexico",
      "value": "mx"
    },
    {
      "label": "Micronesia, Federated States of",
      "value": "fm"
    },
    {
      "label": "Moldova, Republic of",
      "value": "md"
    },
    {
      "label": "Monaco",
      "value": "mc"
    },
    {
      "label": "Mongolia",
      "value": "mn"
    },
    {
      "label": "Montserrat",
      "value": "ms"
    },
    {
      "label": "Morocco",
      "value": "ma"
    },
    {
      "label": "Mozambique",
      "value": "mz"
    },
    {
      "label": "Myanmar",
      "value": "mm"
    },
    {
      "label": "Namibia",
      "value": "na"
    },
    {
      "label": "Nauru",
      "value": "nr"
    },
    {
      "label": "Nepal",
      "value": "np"
    },
    {
      "label": "Netherlands",
      "value": "nl"
    },
    {
      "label": "Netherlands Antilles",
      "value": "an"
    },
    {
      "label": "New Caledonia",
      "value": "nc"
    },
    {
      "label": "New Zealand",
      "value": "nz"
    },
    {
      "label": "Nicaragua",
      "value": "ni"
    },
    {
      "label": "Niger",
      "value": "ne"
    },
    {
      "label": "Nigeria",
      "value": "ng"
    },
    {
      "label": "Niue",
      "value": "nu"
    },
    {
      "label": "Norfolk Island",
      "value": "nf"
    },
    {
      "label": "Northern Mariana Islands",
      "value": "mp"
    },
    {
      "label": "Norway",
      "value": "no"
    },
    {
      "label": "Oman",
      "value": "om"
    },
    {
      "label": "Pakistan",
      "value": "pk"
    },
    {
      "label": "Palau",
      "value": "pw"
    },
    {
      "label": "Palestinian Territory, Occupied",
      "value": "ps"
    },
    {
      "label": "Panama",
      "value": "pa"
    },
    {
      "label": "Papua New Guinea",
      "value": "pg"
    },
    {
      "label": "Paraguay",
      "value": "py"
    },
    {
      "label": "Peru",
      "value": "pe"
    },
    {
      "label": "Philippines",
      "value": "ph"
    },
    {
      "label": "Pitcairn",
      "value": "pn"
    },
    {
      "label": "Poland",
      "value": "pl"
    },
    {
      "label": "Portugal",
      "value": "pt"
    },
    {
      "label": "Puerto Rico",
      "value": "pr"
    },
    {
      "label": "Qatar",
      "value": "qa"
    },
    {
      "label": "Reunion",
      "value": "re"
    },
    {
      "label": "Romania",
      "value": "ro"
    },
    {
      "label": "Russian Federation",
      "value": "ru"
    },
    {
      "label": "RWANDA",
      "value": "rw"
    },
    {
      "label": "Saint Helena",
      "value": "sh"
    },
    {
      "label": "Saint Kitts and Nevis",
      "value": "kn"
    },
    {
      "label": "Saint Lucia",
      "value": "lc"
    },
    {
      "label": "Saint Pierre and Miquelon",
      "value": "pm"
    },
    {
      "label": "Saint Vincent and the Grenadines",
      "value": "vc"
    },
    {
      "label": "Samoa",
      "value": "ws"
    },
    {
      "label": "San Marino",
      "value": "sm"
    },
    {
      "label": "Sao Tome and Principe",
      "value": "st"
    },
    {
      "label": "Saudi Arabia",
      "value": "sa"
    },
    {
      "label": "Senegal",
      "value": "sn"
    },
    {
      "label": "Serbia and Montenegro",
      "value": "cs"
    },
    {
      "label": "Seychelles",
      "value": "sc"
    },
    {
      "label": "Sierra Leone",
      "value": "sl"
    },
    {
      "label": "Singapore",
      "value": "sg"
    },
    {
      "label": "Slovakia",
      "value": "sk"
    },
    {
      "label": "Slovenia",
      "value": "si"
    },
    {
      "label": "Solomon Islands",
      "value": "sb"
    },
    {
      "label": "Somalia",
      "value": "so"
    },
    {
      "label": "South Africa",
      "value": "za"
    },
    {
      "label": "South Georgia and the South Sandwich Islands",
      "value": "gs"
    },
    {
      "label": "Spain",
      "value": "es"
    },
    {
      "label": "Sri Lanka",
      "value": "lk"
    },
    {
      "label": "Sudan",
      "value": "sd"
    },
    {
      "label": "Suriname",
      "value": "sr"
    },
    {
      "label": "Svalbard and Jan Mayen",
      "value": "sj"
    },
    {
      "label": "Swaziland",
      "value": "sz"
    },
    {
      "label": "Sweden",
      "value": "se"
    },
    {
      "label": "Switzerland",
      "value": "ch"
    },
    {
      "label": "Syrian Arab Republic",
      "value": "sy"
    },
    {
      "label": "Taiwan, Province of China",
      "value": "tw"
    },
    {
      "label": "Tajikistan",
      "value": "tj"
    },
    {
      "label": "Tanzania, United Republic of",
      "value": "tz"
    },
    {
      "label": "Thailand",
      "value": "th"
    },
    {
      "label": "Timor-Leste",
      "value": "tl"
    },
    {
      "label": "Togo",
      "value": "tg"
    },
    {
      "label": "Tokelau",
      "value": "tk"
    },
    {
      "label": "Tonga",
      "value": "to"
    },
    {
      "label": "Trinidad and Tobago",
      "value": "tt"
    },
    {
      "label": "Tunisia",
      "value": "tn"
    },
    {
      "label": "Turkey",
      "value": "tr"
    },
    {
      "label": "Turkmenistan",
      "value": "tm"
    },
    {
      "label": "Turks and Caicos Islands",
      "value": "tc"
    },
    {
      "label": "Tuvalu",
      "value": "tv"
    },
    {
      "label": "Uganda",
      "value": "ug"
    },
    {
      "label": "Ukraine",
      "value": "ua"
    },
    {
      "label": "United Arab Emirates",
      "value": "ae"
    },
    {
      "label": "United Kingdom",
      "value": "gb"
    },
    {
      "label": "United States (USA)",
      "value": "us"
    },
    {
      "label": "United States Minor Outlying Islands",
      "value": "um"
    },
    {
      "label": "Uruguay",
      "value": "uy"
    },
    {
      "label": "Uzbekistan",
      "value": "uz"
    },
    {
      "label": "Vanuatu",
      "value": "vu"
    },
    {
      "label": "Venezuela",
      "value": "ve"
    },
    {
      "label": "Viet Nam",
      "value": "vn"
    },
    {
      "label": "Virgin Islands, British",
      "value": "vg"
    },
    {
      "label": "Virgin Islands, U.S.",
      "value": "vi"
    },
    {
      "label": "Wallis and Futuna",
      "value": "wf"
    },
    {
      "label": "Western Sahara",
      "value": "eh"
    },
    {
      "label": "Yemen",
      "value": "ye"
    },
    {
      "label": "Zambia",
      "value": "zm"
    },
    {
      "label": "Zimbabwe",
      "value": "zw"
    }
  ]
}

// export function getCountryOptions(){
//   return [
//     {
//       "label": "Afghanistan",
//       "value": "af"
//     },
//     {
//       "label": "Åland Islands",
//       "value": "ax"
//     },
//     {
//       "label": "Albania",
//       "value": "al"
//     },
//     {
//       "label": "Algeria",
//       "value": "dz"
//     },
//     {
//       "label": "American Samoa",
//       "value": "as"
//     },
//     {
//       "label": "AndorrA",
//       "value": "ad"
//     },
//     {
//       "label": "Angola",
//       "value": "ao"
//     },
//     {
//       "label": "Anguilla",
//       "value": "ai"
//     },
//     {
//       "label": "Antarctica",
//       "value": "aq"
//     },
//     {
//       "label": "Antigua and Barbuda",
//       "value": "ag"
//     },
//     {
//       "label": "Argentina",
//       "value": "ar"
//     },
//     {
//       "label": "Armenia",
//       "value": "am"
//     },
//     {
//       "label": "Aruba",
//       "value": "aw"
//     },
//     {
//       "label": "Australia",
//       "value": "au"
//     },
//     {
//       "label": "Austria",
//       "value": "at"
//     },
//     {
//       "label": "Azerbaijan",
//       "value": "az"
//     },
//     {
//       "label": "Bahamas",
//       "value": "bs"
//     },
//     {
//       "label": "Bahrain",
//       "value": "bh"
//     },
//     {
//       "label": "Bangladesh",
//       "value": "bd"
//     },
//     {
//       "label": "Barbados",
//       "value": "bb"
//     },
//     {
//       "label": "Belarus",
//       "value": "by"
//     },
//     {
//       "label": "Belgium",
//       "value": "be"
//     },
//     {
//       "label": "Belize",
//       "value": "bz"
//     },
//     {
//       "label": "Benin",
//       "value": "bj"
//     },
//     {
//       "label": "Bermuda",
//       "value": "bm"
//     },
//     {
//       "label": "Bhutan",
//       "value": "bt"
//     },
//     {
//       "label": "Bolivia",
//       "value": "bo"
//     },
//     {
//       "label": "Bosnia and Herzegovina",
//       "value": "ba"
//     },
//     {
//       "label": "Botswana",
//       "value": "bw"
//     },
//     {
//       "label": "Bouvet Island",
//       "value": "bv"
//     },
//     {
//       "label": "Brazil",
//       "value": "br"
//     },
//     {
//       "label": "British Indian Ocean Territory",
//       "value": "io"
//     },
//     {
//       "label": "Brunei Darussalam",
//       "value": "bn"
//     },
//     {
//       "label": "Bulgaria",
//       "value": "bg"
//     },
//     {
//       "label": "Burkina Faso",
//       "value": "bf"
//     },
//     {
//       "label": "Burundi",
//       "value": "bi"
//     },
//     {
//       "label": "Cambodia",
//       "value": "kh"
//     },
//     {
//       "label": "Cameroon",
//       "value": "cm"
//     },
//     {
//       "label": "Canada",
//       "value": "ca"
//     },
//     {
//       "label": "Cape Verde",
//       "value": "cv"
//     },
//     {
//       "label": "Cayman Islands",
//       "value": "ky"
//     },
//     {
//       "label": "Central African Republic",
//       "value": "cf"
//     },
//     {
//       "label": "Chad",
//       "value": "td"
//     },
//     {
//       "label": "Chile",
//       "value": "cl"
//     },
//     {
//       "label": "China",
//       "value": "cn"
//     },
//     {
//       "label": "Christmas Island",
//       "value": "cx"
//     },
//     {
//       "label": "Cocos (Keeling) Islands",
//       "value": "cc"
//     },
//     {
//       "label": "Colombia",
//       "value": "co"
//     },
//     {
//       "label": "Comoros",
//       "value": "km"
//     },
//     {
//       "label": "Congo",
//       "value": "cg"
//     },
//     {
//       "label": "Congo, The Democratic Republic of the",
//       "value": "cd"
//     },
//     {
//       "label": "Cook Islands",
//       "value": "ck"
//     },
//     {
//       "label": "Costa Rica",
//       "value": "cr"
//     },
//     {
//       "label": "Cote D'Ivoire",
//       "value": "ci"
//     },
//     {
//       "label": "Croatia",
//       "value": "hr"
//     },
//     {
//       "label": "Cuba",
//       "value": "cu"
//     },
//     {
//       "label": "Cyprus",
//       "value": "cy"
//     },
//     {
//       "label": "Czech Republic",
//       "value": "cz"
//     },
//     {
//       "label": "Denmark",
//       "value": "dk"
//     },
//     {
//       "label": "Djibouti",
//       "value": "dj"
//     },
//     {
//       "label": "Dominica",
//       "value": "dm"
//     },
//     {
//       "label": "Dominican Republic",
//       "value": "do"
//     },
//     {
//       "label": "Ecuador",
//       "value": "ec"
//     },
//     {
//       "label": "Egypt",
//       "value": "eg"
//     },
//     {
//       "label": "El Salvador",
//       "value": "sv"
//     },
//     {
//       "label": "Equatorial Guinea",
//       "value": "gq"
//     },
//     {
//       "label": "Eritrea",
//       "value": "er"
//     },
//     {
//       "label": "Estonia",
//       "value": "ee"
//     },
//     {
//       "label": "Ethiopia",
//       "value": "et"
//     },
//     {
//       "label": "Falkland Islands (Malvinas)",
//       "value": "fk"
//     },
//     {
//       "label": "Faroe Islands",
//       "value": "fo"
//     },
//     {
//       "label": "Fiji",
//       "value": "fj"
//     },
//     {
//       "label": "Finland",
//       "value": "fi"
//     },
//     {
//       "label": "France",
//       "value": "fr"
//     },
//     {
//       "label": "French Guiana",
//       "value": "gf"
//     },
//     {
//       "label": "French Polynesia",
//       "value": "pf"
//     },
//     {
//       "label": "French Southern Territories",
//       "value": "tf"
//     },
//     {
//       "label": "Gabon",
//       "value": "ga"
//     },
//     {
//       "label": "Gambia",
//       "value": "gm"
//     },
//     {
//       "label": "Georgia",
//       "value": "ge"
//     },
//     {
//       "label": "Germany",
//       "value": "de"
//     },
//     {
//       "label": "Ghana",
//       "value": "gh"
//     },
//     {
//       "label": "Gibraltar",
//       "value": "gi"
//     },
//     {
//       "label": "Greece",
//       "value": "gr"
//     },
//     {
//       "label": "Greenland",
//       "value": "gl"
//     },
//     {
//       "label": "Grenada",
//       "value": "gd"
//     },
//     {
//       "label": "Guadeloupe",
//       "value": "gp"
//     },
//     {
//       "label": "Guam",
//       "value": "gu"
//     },
//     {
//       "label": "Guatemala",
//       "value": "gt"
//     },
//     {
//       "label": "Guernsey",
//       "value": "gg"
//     },
//     {
//       "label": "Guinea",
//       "value": "gn"
//     },
//     {
//       "label": "Guinea-Bissau",
//       "value": "gw"
//     },
//     {
//       "label": "Guyana",
//       "value": "gy"
//     },
//     {
//       "label": "Haiti",
//       "value": "ht"
//     },
//     {
//       "label": "Heard Island and Mcdonald Islands",
//       "value": "hm"
//     },
//     {
//       "label": "Holy See (Vatican City State)",
//       "value": "va"
//     },
//     {
//       "label": "Honduras",
//       "value": "hn"
//     },
//     {
//       "label": "Hong Kong",
//       "value": "hk"
//     },
//     {
//       "label": "Hungary",
//       "value": "hu"
//     },
//     {
//       "label": "Iceland",
//       "value": "is"
//     },
//     {
//       "label": "India",
//       "value": "in"
//     },
//     {
//       "label": "Indonesia",
//       "value": "id"
//     },
//     {
//       "label": "Iran, Islamic Republic Of",
//       "value": "ir"
//     },
//     {
//       "label": "Iraq",
//       "value": "iq"
//     },
//     {
//       "label": "Ireland",
//       "value": "ie"
//     },
//     {
//       "label": "Isle of Man",
//       "value": "im"
//     },
//     {
//       "label": "Israel",
//       "value": "il"
//     },
//     {
//       "label": "Italy",
//       "value": "it"
//     },
//     {
//       "label": "Jamaica",
//       "value": "jm"
//     },
//     {
//       "label": "Japan",
//       "value": "jp"
//     },
//     {
//       "label": "Jersey",
//       "value": "je"
//     },
//     {
//       "label": "Jordan",
//       "value": "jo"
//     },
//     {
//       "label": "Kazakhstan",
//       "value": "kz"
//     },
//     {
//       "label": "Kenya",
//       "value": "ke"
//     },
//     {
//       "label": "Kiribati",
//       "value": "ki"
//     },
//     {
//       "label": "Korea, Democratic People'S Republic of",
//       "value": "kp"
//     },
//     {
//       "label": "Korea, Republic of",
//       "value": "kr"
//     },
//     {
//       "label": "Kuwait",
//       "value": "kw"
//     },
//     {
//       "label": "Kyrgyzstan",
//       "value": "kg"
//     },
//     {
//       "label": "Lao People'S Democratic Republic",
//       "value": "la"
//     },
//     {
//       "label": "Latvia",
//       "value": "lv"
//     },
//     {
//       "label": "Lebanon",
//       "value": "lb"
//     },
//     {
//       "label": "Lesotho",
//       "value": "ls"
//     },
//     {
//       "label": "Liberia",
//       "value": "lr"
//     },
//     {
//       "label": "Libyan Arab Jamahiriya",
//       "value": "ly"
//     },
//     {
//       "label": "Liechtenstein",
//       "value": "li"
//     },
//     {
//       "label": "Lithuania",
//       "value": "lt"
//     },
//     {
//       "label": "Luxembourg",
//       "value": "lu"
//     },
//     {
//       "label": "Macao",
//       "value": "mo"
//     },
//     {
//       "label": "Macedonia, The Former Yugoslav Republic of",
//       "value": "mk"
//     },
//     {
//       "label": "Madagascar",
//       "value": "mg"
//     },
//     {
//       "label": "Malawi",
//       "value": "mw"
//     },
//     {
//       "label": "Malaysia",
//       "value": "my"
//     },
//     {
//       "label": "Maldives",
//       "value": "mv"
//     },
//     {
//       "label": "Mali",
//       "value": "ml"
//     },
//     {
//       "label": "Malta",
//       "value": "mt"
//     },
//     {
//       "label": "Marshall Islands",
//       "value": "mh"
//     },
//     {
//       "label": "Martinique",
//       "value": "mq"
//     },
//     {
//       "label": "Mauritania",
//       "value": "mr"
//     },
//     {
//       "label": "Mauritius",
//       "value": "mu"
//     },
//     {
//       "label": "Mayotte",
//       "value": "yt"
//     },
//     {
//       "label": "Mexico",
//       "value": "mx"
//     },
//     {
//       "label": "Micronesia, Federated States of",
//       "value": "fm"
//     },
//     {
//       "label": "Moldova, Republic of",
//       "value": "md"
//     },
//     {
//       "label": "Monaco",
//       "value": "mc"
//     },
//     {
//       "label": "Mongolia",
//       "value": "mn"
//     },
//     {
//       "label": "Montserrat",
//       "value": "ms"
//     },
//     {
//       "label": "Morocco",
//       "value": "ma"
//     },
//     {
//       "label": "Mozambique",
//       "value": "mz"
//     },
//     {
//       "label": "Myanmar",
//       "value": "mm"
//     },
//     {
//       "label": "Namibia",
//       "value": "na"
//     },
//     {
//       "label": "Nauru",
//       "value": "nr"
//     },
//     {
//       "label": "Nepal",
//       "value": "np"
//     },
//     {
//       "label": "Netherlands",
//       "value": "nl"
//     },
//     {
//       "label": "Netherlands Antilles",
//       "value": "an"
//     },
//     {
//       "label": "New Caledonia",
//       "value": "nc"
//     },
//     {
//       "label": "New Zealand",
//       "value": "nz"
//     },
//     {
//       "label": "Nicaragua",
//       "value": "ni"
//     },
//     {
//       "label": "Niger",
//       "value": "ne"
//     },
//     {
//       "label": "Nigeria",
//       "value": "ng"
//     },
//     {
//       "label": "Niue",
//       "value": "nu"
//     },
//     {
//       "label": "Norfolk Island",
//       "value": "nf"
//     },
//     {
//       "label": "Northern Mariana Islands",
//       "value": "mp"
//     },
//     {
//       "label": "Norway",
//       "value": "no"
//     },
//     {
//       "label": "Oman",
//       "value": "om"
//     },
//     {
//       "label": "Pakistan",
//       "value": "pk"
//     },
//     {
//       "label": "Palau",
//       "value": "pw"
//     },
//     {
//       "label": "Palestinian Territory, Occupied",
//       "value": "ps"
//     },
//     {
//       "label": "Panama",
//       "value": "pa"
//     },
//     {
//       "label": "Papua New Guinea",
//       "value": "pg"
//     },
//     {
//       "label": "Paraguay",
//       "value": "py"
//     },
//     {
//       "label": "Peru",
//       "value": "pe"
//     },
//     {
//       "label": "Philippines",
//       "value": "ph"
//     },
//     {
//       "label": "Pitcairn",
//       "value": "pn"
//     },
//     {
//       "label": "Poland",
//       "value": "pl"
//     },
//     {
//       "label": "Portugal",
//       "value": "pt"
//     },
//     {
//       "label": "Puerto Rico",
//       "value": "pr"
//     },
//     {
//       "label": "Qatar",
//       "value": "qa"
//     },
//     {
//       "label": "Reunion",
//       "value": "re"
//     },
//     {
//       "label": "Romania",
//       "value": "ro"
//     },
//     {
//       "label": "Russian Federation",
//       "value": "ru"
//     },
//     {
//       "label": "RWANDA",
//       "value": "rw"
//     },
//     {
//       "label": "Saint Helena",
//       "value": "sh"
//     },
//     {
//       "label": "Saint Kitts and Nevis",
//       "value": "kn"
//     },
//     {
//       "label": "Saint Lucia",
//       "value": "lc"
//     },
//     {
//       "label": "Saint Pierre and Miquelon",
//       "value": "pm"
//     },
//     {
//       "label": "Saint Vincent and the Grenadines",
//       "value": "vc"
//     },
//     {
//       "label": "Samoa",
//       "value": "ws"
//     },
//     {
//       "label": "San Marino",
//       "value": "sm"
//     },
//     {
//       "label": "Sao Tome and Principe",
//       "value": "st"
//     },
//     {
//       "label": "Saudi Arabia",
//       "value": "sa"
//     },
//     {
//       "label": "Senegal",
//       "value": "sn"
//     },
//     {
//       "label": "Serbia and Montenegro",
//       "value": "cs"
//     },
//     {
//       "label": "Seychelles",
//       "value": "sc"
//     },
//     {
//       "label": "Sierra Leone",
//       "value": "sl"
//     },
//     {
//       "label": "Singapore",
//       "value": "sg"
//     },
//     {
//       "label": "Slovakia",
//       "value": "sk"
//     },
//     {
//       "label": "Slovenia",
//       "value": "si"
//     },
//     {
//       "label": "Solomon Islands",
//       "value": "sb"
//     },
//     {
//       "label": "Somalia",
//       "value": "so"
//     },
//     {
//       "label": "South Africa",
//       "value": "za"
//     },
//     {
//       "label": "South Georgia and the South Sandwich Islands",
//       "value": "gs"
//     },
//     {
//       "label": "Spain",
//       "value": "es"
//     },
//     {
//       "label": "Sri Lanka",
//       "value": "lk"
//     },
//     {
//       "label": "Sudan",
//       "value": "sd"
//     },
//     {
//       "label": "Suriname",
//       "value": "sr"
//     },
//     {
//       "label": "Svalbard and Jan Mayen",
//       "value": "sj"
//     },
//     {
//       "label": "Swaziland",
//       "value": "sz"
//     },
//     {
//       "label": "Sweden",
//       "value": "se"
//     },
//     {
//       "label": "Switzerland",
//       "value": "ch"
//     },
//     {
//       "label": "Syrian Arab Republic",
//       "value": "sy"
//     },
//     {
//       "label": "Taiwan, Province of China",
//       "value": "tw"
//     },
//     {
//       "label": "Tajikistan",
//       "value": "tj"
//     },
//     {
//       "label": "Tanzania, United Republic of",
//       "value": "tz"
//     },
//     {
//       "label": "Thailand",
//       "value": "th"
//     },
//     {
//       "label": "Timor-Leste",
//       "value": "tl"
//     },
//     {
//       "label": "Togo",
//       "value": "tg"
//     },
//     {
//       "label": "Tokelau",
//       "value": "tk"
//     },
//     {
//       "label": "Tonga",
//       "value": "to"
//     },
//     {
//       "label": "Trinidad and Tobago",
//       "value": "tt"
//     },
//     {
//       "label": "Tunisia",
//       "value": "tn"
//     },
//     {
//       "label": "Turkey",
//       "value": "tr"
//     },
//     {
//       "label": "Turkmenistan",
//       "value": "tm"
//     },
//     {
//       "label": "Turks and Caicos Islands",
//       "value": "tc"
//     },
//     {
//       "label": "Tuvalu",
//       "value": "tv"
//     },
//     {
//       "label": "Uganda",
//       "value": "ug"
//     },
//     {
//       "label": "Ukraine",
//       "value": "ua"
//     },
//     {
//       "label": "United Arab Emirates",
//       "value": "ae"
//     },
//     {
//       "label": "United Kingdom",
//       "value": "gb"
//     },
//     {
//       "label": "United States",
//       "value": "us"
//     },
//     {
//       "label": "United States Minor Outlying Islands",
//       "value": "um"
//     },
//     {
//       "label": "Uruguay",
//       "value": "uy"
//     },
//     {
//       "label": "Uzbekistan",
//       "value": "uz"
//     },
//     {
//       "label": "Vanuatu",
//       "value": "vu"
//     },
//     {
//       "label": "Venezuela",
//       "value": "ve"
//     },
//     {
//       "label": "Viet Nam",
//       "value": "vn"
//     },
//     {
//       "label": "Virgin Islands, British",
//       "value": "vg"
//     },
//     {
//       "label": "Virgin Islands, U.S.",
//       "value": "vi"
//     },
//     {
//       "label": "Wallis and Futuna",
//       "value": "wf"
//     },
//     {
//       "label": "Western Sahara",
//       "value": "eh"
//     },
//     {
//       "label": "Yemen",
//       "value": "ye"
//     },
//     {
//       "label": "Zambia",
//       "value": "zm"
//     },
//     {
//       "label": "Zimbabwe",
//       "value": "zw"
//     }
//   ]
// }



// WEBPACK FOOTER //
// ./src/util/data.js